import { jsx as a, jsxs as c } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { chakra as s, Tab as b } from "@chakra-ui/react";
import { useTabsStyles as f } from "./Tabs.context.es.js";
const x = m(
  ({ children: e, count: r, isDisabled: o, trackId: i, ...d }, n) => {
    const t = f();
    return /* @__PURE__ */ a(
      s.div,
      {
        ref: n,
        display: "flex",
        width: { base: "100%", md: "auto" },
        justifyContent: "center",
        "track-id": i,
        children: /* @__PURE__ */ c(s.button, { as: b, isDisabled: o, __css: t.tab, ...d, children: [
          e,
          r && /* @__PURE__ */ a(s.span, { __css: t.badge, children: r })
        ] })
      }
    );
  }
);
export {
  x as Tab
};
//# sourceMappingURL=Tab.es.js.map
